define([
    './AddressDetails',
    './NameDetails',
    './CompanyNameDetails',
    './UiMaskDirective',
    './ClampTextDirective',
    './DateDropDownDirective',
    './AlertDirective',
    './BinaryChoice',
    './BinaryChoiceGroup',
    './YesNo',
    './YesNoGroup',
    './Stepper',
    './StepperSelect',
    './PhoneDetails',
    'portalConfig'
], (AddressDetails, NameDetails, CompanyNameDetails, UiMaskDirective, ClampTextDirective, DateDropDownDirective, AlertDirective,
    BinaryChoice, BinaryChoiceGroup, YesNo, YesNoGroup,
    Stepper, StepperSelect, PhoneDetails)=> {
    return angular.module('edge.platform.widgets.inputs', ['portal.config'])
        .value('uiMaskConfig', {
            maskDefinitions: {
                '9': /\d/,
                'A': /[a-zA-Z]/,
                '*': /[a-zA-Z0-9]/
            },
            clearOnBlur: false,
            clearOnBlurPlaceholder: false,
            eventsToHandle: ['input', 'keyup', 'click', 'focus'],
            addDefaultPlaceholder: true
        })
        .directive('gwPlAddressDetails', AddressDetails)
        .directive('gwPlNameDetails', NameDetails)
        .directive('gwPlCompanyNameDetails', CompanyNameDetails)
        .directive('gwPlUiMask', UiMaskDirective)
        .directive('gwPlClampText', ClampTextDirective)
        .directive('gwPlDateDropDown', DateDropDownDirective)
        .directive('gwPlAlert', AlertDirective)
        .directive('gwPlBinaryChoice', BinaryChoice)
        .directive('gwPlBinaryChoiceGroup', BinaryChoiceGroup)
        .directive('gwPlYesNo', YesNo)
        .directive('gwPlYesNoGroup', YesNoGroup)
        .directive('gwPlStepperCtrl', Stepper)
        .directive('gwPlStepperSelect', StepperSelect)
        .directive('gwPlPhoneDetails', PhoneDetails);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/inputs/module.js
 **/